module.exports = __webpack_public_path__ + "static/media/IMG_0074.dc336d7b.jpg";